export default class tccf7Create {
  escapeHTML(str) {
    return str.replace(/&/g, '&amp;')
              .replace(/</g, '&lt;')
              .replace(/>/g, '&gt;')
              .replace(/"/g, '&quot;')
              .replace(/'/g, '&#39;');
  }
  
  createConfirmTable(form , wrap, noneClass) {
    const inputs = form.querySelectorAll('input, textarea, select');
    const checkInput = ['textarea', 'select'];
    let   counter = 0;
    let   value = '';
    
    inputs.forEach(input => {
      const type         = input.type || input.tagName.toLowerCase();
      const isCheckInput = checkInput.includes(type);
      const typeElem     = isCheckInput ? type : `input[type="${type}"]`;
      let name           = input.getAttribute('name') || '';
          name           = name.replace(/\[\]$/, '');
      const data         = name ? `[data-name="${name}"]` : false;
      const dataElem     = data ? form.querySelector(data) || input : input;
      const length       = dataElem ? dataElem.querySelectorAll(typeElem)?.length : 0;
      const selected     = input.getAttribute('data-selected-value') || false;
      const accept       = input.closest('.wpcf7-acceptance');

      if(length > 1 && counter < length){
        counter++;
      }
      
      let bool  = true;
      if(accept && input.checked){
        value = input.nextSibling ? input.nextSibling.textContent : '';
      } else if (type === 'radio' || type === 'checkbox' ) {
        bool = false;
        value += input.checked ? `${input.value} ` : '';
      } else if (type === 'file') {
        input.classList.add(noneClass);
        this.createFile(input, dataElem);
        counter = 0;
        value   = '';
        return;
      } else if (selected) {
        value = selected;
      } else if (type === 'url') {
        value = input.value ? input.value : 'URL未入力';
      } else {
        value = input.value;
      }

      const span     = document.createElement('span');
      span.innerHTML = this.escapeHTML(value.trim()).replace(/\n/g, '<br>');
      
      if (dataElem && bool) {
        dataElem.replaceWith(span);
        counter = 0;
        value   = '';
      } else if (dataElem && !bool && (counter === length || length === 1)) {
        const output = value.trim() === '' ? '未選択' : value.trim();
        span.innerHTML = this.escapeHTML(output).replace(/\n/g, '<br>');
        dataElem.replaceWith(span);
        counter = 0;
        value   = '';
      }
    });
    wrap.appendChild(form);
  }

  createFile(input, dataElem) {
    if (input.files.length === 0) {
      const span = document.createElement('span');
      span.textContent = 'ファイルが選択されていません';
      dataElem.appendChild(span);
      return;
    }
  
    Array.from(input.files).forEach(file => {
      const span = document.createElement('span');
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = document.createElement('img');
          img.src = e.target.result;
          dataElem.appendChild(img);
        };
        reader.readAsDataURL(file);
      } else {
        span.textContent = file.name;
        dataElem.appendChild(span);
      }
    });
  }

  createConfirm(confirmWrapId,inputWrap,form) {
    const confirmWrapElem = document.createElement('div');
    confirmWrapElem.setAttribute('id', confirmWrapId);
    if(inputWrap) {
      form.insertBefore(confirmWrapElem, inputWrap.nextSibling); 
    }else{
      form.appendChild(confirmWrapElem);
    }
  }

  createComplete(completeId,confirmWrap,success) {
    this.remove(completeId);
    const completeWrap  = document.createElement('div');
    const completeTitle = document.createElement('p');
    const completeText = document.createElement('p');
    completeWrap.setAttribute('id', completeId);
    completeTitle.classList.add('complete-ttl');
    completeTitle.textContent = '送信完了';
    completeText.innerHTML    = 'フォームの送信が完了しました。自動返信メールが届かない場合は、迷惑メールフォルダに振り分けられていないかご確認ください。';
    if( success === false ) {
      completeTitle.textContent = '送信失敗';
      completeText.innerHTML    = '何らかの原因でフォームの送信がうまくいきませんでした。大変ご迷惑をおかけし、申し訳ございません。再度送信いただくか、時間をおいてお試しください。';
    }
    completeWrap.appendChild(completeTitle);
    completeWrap.appendChild(completeText);
    confirmWrap.appendChild(completeWrap);
  }

  createCursor(cursorId) {
    const cursorWrap  = document.createElement('span'); 
    cursorWrap.setAttribute('id', cursorId);
    document.body.appendChild(cursorWrap);
    document.addEventListener('mousemove', (e) => {
      if (cursorWrap) {
        cursorWrap.style.top = `${e.clientY}px`;
        cursorWrap.style.left = `${e.clientX}px`;
      }
    });
  }

  remove(id) {
    document.getElementById(id)?.remove();
  }
}
